/* eslint-disable max-len */
import React from 'react';

export default function ClearAllIcon() {
  return (
    <svg width="20" height="21" fill="none" viewBox="0 0 20 21">
      <path
        fill="#6F6C80"
        d="M7.658 9.79a1.004 1.004 0 00-1.42 1.42l3 3a1 1 0 00.71.29.999.999 0 00.72-.34l7-8a1 1 0 00-1.5-1.32l-6.22 7.2-2.29-2.25z"
      />
      <path
        fill="#6F6C80"
        d="M18.948 9.5a1 1 0 00-1 1A8 8 0 015.51 17.154 8 8 0 014.278 4.86a7.93 7.93 0 015.67-2.36 8.79 8.79 0 011.9.22 1 1 0 10.47-1.94A10.54 10.54 0 009.948.5a10 10 0 00-7 17.09 9.93 9.93 0 007 2.91 10 10 0 0010-10 1 1 0 00-1-1z"
      />
    </svg>
  );
}
